module.exports = __webpack_public_path__ + "static/media/face-smile.74f0a1b3.svg";